import { IDistinctColor } from "@interfaces/modelColorDetails";
import {
  ColorVariant,
  ColorSelectionData,
} from "@components/organisms/ColorSelectionModal/colorSelectionData";

export const transformToColorSelectionData = (
  colors: IDistinctColor[],
  variantName: string,
  confirmButtonText: string = "Confirm Selection",
  stockStatus?: { available?: number; message?: string },
  includePricingAndDelivery: boolean = false
): ColorSelectionData => {
  const transformedColors: ColorVariant[] = colors.map((color) => ({
    id: color.id.toString(),
    name: color.name,
    colorCode: color.hexCodes?.[0] || "#000000",
    colorImage: "",
    currentPrice: includePricingAndDelivery ? "" : "",
    originalPrice: includePricingAndDelivery ? "" : "",
    savings: includePricingAndDelivery ? "" : "",
    isExpressDelivery: includePricingAndDelivery ? false : false,
    isSelected: false,
    waitingPeriod: includePricingAndDelivery ? "" : "",
  }));

  return {
    variantName,
    stockStatus: stockStatus || { available: 0, message: "" },
    colors: transformedColors,
    confirmButtonText,
  };
};
